import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "form", "reason", "submitButton"]

  connect() {
    // Close modal on escape key
    this.escapeHandler = (e) => {
      if (e.key === "Escape") {
        this.close()
      }
    }
    document.addEventListener("keydown", this.escapeHandler)
  }

  disconnect() {
    document.removeEventListener("keydown", this.escapeHandler)
  }

  open(event) {
    event.preventDefault()

    const button = event.currentTarget
    const action = button.dataset.cancelAction

    // Set form action
    this.formTarget.action = action

    // Clear previous reason
    this.reasonTarget.value = ""

    // Show modal with animation
    this.modalTarget.classList.remove("hidden")
    setTimeout(() => {
      this.modalTarget.classList.add("opacity-100")
      this.modalTarget.querySelector(".transform").classList.remove("scale-95")
      this.modalTarget.querySelector(".transform").classList.add("scale-100")
    }, 10)

    // Focus on textarea
    setTimeout(() => {
      this.reasonTarget.focus()
    }, 200)
  }

  close() {
    // Hide modal with animation
    this.modalTarget.classList.remove("opacity-100")
    this.modalTarget.querySelector(".transform").classList.remove("scale-100")
    this.modalTarget.querySelector(".transform").classList.add("scale-95")

    setTimeout(() => {
      this.modalTarget.classList.add("hidden")
    }, 200)
  }

  submit(event) {
    event.preventDefault()

    const reason = this.reasonTarget.value.trim()

    if (reason === "") {
      alert("Por favor, informe o motivo do cancelamento.")
      this.reasonTarget.focus()
      return
    }

    // Disable submit button to prevent double submission
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.textContent = "Cancelando..."

    // Submit the form
    this.formTarget.submit()
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }
}
